module.exports = __webpack_public_path__ + "static/media/menu.4ffa36f2.svg";